import '@fontsource-variable/inter';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'src/polyfills';
import { App } from 'src/ui/App';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
